/** The name a widget's one `query` goes by: `sequent_core`'s `DEFAULT_QUERY_NAME`. */
export var DEFAULT_QUERY_NAME = "data";
/** A widget's queries by name; its one `query` is called `data`. */
export function widgetQueries(widget) {
    var _a;
    if ((widget === null || widget === void 0 ? void 0 : widget.queries) && Object.keys(widget.queries).length)
        return widget.queries;
    return (widget === null || widget === void 0 ? void 0 : widget.query) ? (_a = {}, _a[DEFAULT_QUERY_NAME] = widget.query, _a) : undefined;
}
/**
 * A section per governed query, in widget order. An older backend sends only
 * `table`, the first query's rows: one section, untitled.
 */
export function dataSections(render, queries) {
    var _a;
    if ((_a = render.tables) === null || _a === void 0 ? void 0 : _a.length) {
        return render.tables.flatMap(function (_a) {
            var query = _a.query, table = _a.table;
            return table ? [{ query: query, table: table, definition: queries === null || queries === void 0 ? void 0 : queries[query] }] : [];
        });
    }
    if (!render.table)
        return [];
    var first = queries ? Object.values(queries)[0] : undefined;
    return [{ query: null, table: render.table, definition: first }];
}
var isRecord = function (value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
};
/** A ratio written out, `[voted, registered]`; not one a selector picks. */
function ratioMeasures(definition) {
    var ratio = definition.ratio;
    return Array.isArray(ratio) &&
        ratio.length === 2 &&
        ratio.every(function (measure) { return typeof measure === "string"; })
        ? [ratio[0], ratio[1]]
        : undefined;
}
/**
 * Column headers for a query's rows: the query's own `labels`, then the
 * platform's words for measures and result columns, then the raw name. A
 * ratio's numerator and denominator are named by their measures, and the
 * group column by the dimension grouped by.
 */
export function columnLabeler(definition, known) {
    var query = isRecord(definition) ? definition : {};
    var labels = isRecord(query.labels) ? query.labels : {};
    var ratio = ratioMeasures(query);
    var measure = function (name) {
        var own = labels[name];
        return typeof own === "string" ? own : known("monitoring.measures.".concat(name));
    };
    return function (column) {
        var _a, _b, _c, _d, _e;
        if (ratio && column === "numerator")
            return (_a = measure(ratio[0])) !== null && _a !== void 0 ? _a : ratio[0];
        if (ratio && column === "denominator")
            return (_b = measure(ratio[1])) !== null && _b !== void 0 ? _b : ratio[1];
        if (column === "group" && typeof query.group_by === "string") {
            return (_c = known("monitoring.columns.".concat(query.group_by))) !== null && _c !== void 0 ? _c : query.group_by;
        }
        return (_e = (_d = measure(column)) !== null && _d !== void 0 ? _d : known("monitoring.columns.".concat(column))) !== null && _e !== void 0 ? _e : column;
    };
}
